export function isHighlightedInSearch(_ref) {
  var matched = _ref.matched,
      fullMatch = _ref.fullMatch,
      isExpanded = _ref.isExpanded,
      highlighted = _ref.highlighted;
  var highlightedInSearch = false;

  if (matched) {
    if (fullMatch) {
      highlightedInSearch = true;
    } else if (!isExpanded) {
      highlightedInSearch = true;
    }
  }

  if (fullMatch || highlighted) {
    highlightedInSearch = true;
  }

  return {
    highlightedInSearch: highlightedInSearch
  };
}